import BillLading from '@/components/BillLading/BillLading';
import jwt_decode from 'jwt-decode';
export default {
    name: "collectAddWriteBill",
	conditionData:'',
	created: function () {
      this.init();
	},
	components:{
      BillLading
	},
    data() {
        return {
					edit: false,
					showBillLading : true,
					showPdf :false,
					billLadingData: {
										shipper: "",
										consignee: "",
										notifyParty: "", ///
										placeOfreceipt: "",
										vessel: "",
										portOfLoading: "",
										portOfTransshipment: "",
										PortOfDischarge: "", ///
										PlaceOfDelivery: "", //
										freightCharges: "", //
										NoOfOriginal: "", //
										declared: "",
										voyageNo: "",
										preCarriageBy: "", //
										planceAndDate: "",
										forwardingAgent: "", //
										finalDestination: "",
										totalNumber: "",
										signedBy: "",
										typeOfMovement: "",
										blNo: "", //
										goodList:[],
										isAddtionalImageDisplay: 1
									},
					addWriteBillForm: {
						signer:'',
						issuingParty_label:'',
						billFormatter: this.$t('c_addWriteBill.billFormatter'),
						billType: this.$t('c_addWriteBill.billType'),
						billAdditionalDescription:'',
						billAdditionalDescriptionOfSend:'',
						billingFee:'',
						issuingTime:'',
						portOfDischarge:'',
						payment:'',
						payType:''
					},
					// 公司下拉列表
					companyList: [],
					// 出单费下拉列表
					costList:[],
					logoType: 1,
					imageType: 1
        }
	},
	computed: {
		rules() {
			return {signer: [
				{ required: true, //是否必填
				message: this.$t('c_addWriteBill.message.signer'), //提示信息
				trigger: 'blur'  //何事件触发
				}
			],
			issuingParty_label: [
				{ required: true, //是否必填
				message: this.$t('c_addWriteBill.message.issuingParty_label'), //提示信息
				trigger: 'blur'  //何事件触发
				}
			],
			billingFee: [
				{ required: true, //是否必填
				message: this.$t('c_addWriteBill.message.billingFee'), //提示信息
				trigger: 'blur'  //何事件触发
				}
			],
			issuingTime: [
				{ required: true, //是否必填
				message: this.$t('c_addWriteBill.message.issuingTime'), //提示信息
				trigger: 'blur'  //何事件触发
				}
			],
			payment: [
				{ required: true, //是否必填
				message: this.$t('c_addWriteBill.message.payment'), //提示信息
				trigger: 'blur'  //何事件触发
				}
			]
		}
		},
		singCompanyList(){
			if(this.addWriteBillForm.issuingParty_label && this.addWriteBillForm.signer){
				if(this.addWriteBillForm.issuingParty_label === this.addWriteBillForm.signer){
					const id = this.addWriteBillForm.issuingParty_label;
					return [{id:id, companyName: this.getCompanyName(id)}]
				}else{
					const isId = this.addWriteBillForm.issuingParty_label;
					const sid = this.addWriteBillForm.signer;
					return [{id:isId, companyName: this.getCompanyName(isId)},
					{id:sid, companyName: this.getCompanyName(sid)}]
				}
			}
			return [];
		},
		logoPath(){
			let url = '/api/file/bill_logo_wiffa.png';
			return url;
			// if (this.logoType === 1){
			// 	return url;
			// }else{
			// 	if(this.addWriteBillForm.issuingParty_label){
			// 		this.companyList.forEach(item => {
			// 			if(item.id === this.addWriteBillForm.issuingParty_label){
			// 				if(item.billLogo){
			// 					url = `/api${item.billLogo}`;
			// 				}else{
			// 					// this.$message.info("该公司未提交LOGO，将使用WIFFA LOGO")
			// 					this.$message.info(this.$t('c_addWriteBill.message.noLogo'))
			// 				}
			// 			}
			// 		});
			// 		return url;
			// 	}else{
			// 		return url;
			// 	}
			// }
		},
		addtionalImagePath(){
			let url = '/api/file/bill_addtional_image_wiffa.png';
			return url;
			// if (this.logoType === 1){
			// 	return url;
			// }else{
			// 	if(this.addWriteBillForm.issuingParty_label){
			// 		this.companyList.forEach(item => {
			// 			if(item.id === this.addWriteBillForm.issuingParty_label){
			// 				if(item.billLogo){
			// 					url = `/api${item.billLogo}`;
			// 				}else{
			// 					// this.$message.info("该公司未提交LOGO，将使用WIFFA LOGO")
			// 					this.$message.info(this.$t('c_addWriteBill.message.noLogo'))
			// 				}
			// 			}
			// 		});
			// 		return url;
			// 	}else{
			// 		return url;
			// 	}
			// }
		},
		imagePath(){
			let url = '/api/file/bill_image_wiffa.png';
			if (this.imageType === 1){
				return url;
			}else{
				if(this.addWriteBillForm.issuingParty_label){
					this.companyList.forEach(item => {
						if(item.id === this.addWriteBillForm.issuingParty_label){
							if(item.billImage){
								url = `/api${item.billImage}`;
							}else{
								// this.$message.info("该公司未提交抬头，将使用WIFFA抬头")
								// this.$message.info(this.$t('c_addWriteBill.message.noImage'))
								this.$message({
									message: this.$t('c_addWriteBill.message.noImage'),
									type: 'info',
									center: true
								});
							}
						}
					});
					return url;
				}else{
					return url;
				}
			}
		}
	},
    methods: {
        init(){
			// 取数据判断是走表单，还是PDF.修改showBillLading和showPdf(互斥)
			this.conditionData = this.$routerUtil.getParam();
			if(this.conditionData.row){
				this.billLadingData = Object.assign({}, this.conditionData.row);
				this.addWriteBillForm = Object.assign({}, this.conditionData.row);
				// 判断LOGO 和 Image
				// 如果不是wiffa
				if(this.conditionData.row.billLogoName !== 'bill_logo_wiffa.png'){
					this.logoType = 2;
				}
				// 如果不是wiffa
				if(this.conditionData.row.billImageName !== 'bill_image_wiffa.png'){
					this.imageType = 2;
				}
				// 如果不是wiffa
				if(this.conditionData.row.billAddtionalImageName !== 'bill_addtional_image_wiffa.png'){
					this.imageType = 2;
				}
			}
			// 查询当前提单中的收单公司建立合作关系的出单公司下拉列表
			const selectSendCompanyParam = {};
			const token = jwt_decode(sessionStorage.getItem('token'));
			selectSendCompanyParam.receiveCompanyId = token.customerCompanyId;
			this.$axios({
				method: "get",
				url: "api/customerCompay/selecCompayCustomer", 
				params: selectSendCompanyParam
				}).then(res => {
					this.companyList = res.data.resultData;
				}).catch(error => {
					console.log(error);
					this.$message({
						message: this.$t('common.message.operateFail'),
						type: 'error',
						center: true
					});
				});
			// 查询出单费集合下拉
			const param = {};
			param.isDefault = 0;
			this.$axios.get('/api/cost/selectCostIsDefault',{params:param}).then(response => {
				this.costList = response.data.resultData;
			}).catch(e => {
				console.log(e);
				this.$message({
					message: this.$t('common.message.operateFail'),
					type: 'error',
					center: true
				});
			});
		},
		submitForm(addWriteBillForm){
			this.$refs[addWriteBillForm].validate(valid => {
				if (valid) {
						var param = new Object();
						param.shipper = this.billLadingData.shipper;
						param.consignee = this.billLadingData.consignee;
						param.notifyParty = this.billLadingData.notifyParty;
						param.placeOfreceipt = this.billLadingData.placeOfreceipt;
						param.vessel = this.billLadingData.vessel;
						param.portOfLoading = this.billLadingData.portOfLoading;
						param.portOfTransshipment = this.billLadingData.portOfTransshipment;
						param.PortOfDischarge = this.billLadingData.PortOfDischarge;
						param.PlaceOfDelivery = this.billLadingData.PlaceOfDelivery;
						param.freightCharges = this.billLadingData.freightCharges;
						param.NoOfOriginal = this.billLadingData.NoOfOriginal;
						param.declared = this.billLadingData.declared;
						param.voyageNo = this.billLadingData.voyageNo;
						param.preCarriageBy = this.billLadingData.preCarriageBy;
						param.planceAndDate = this.billLadingData.planceAndDate;
						param.forwardingAgent = this.billLadingData.forwardingAgent;
						param.signedBy = this.billLadingData.signedBy;
						param.typeOfMovement = this.billLadingData.typeOfMovement;
						param.blNo = this.billLadingData.blNo;
						param.finalDestination = this.billLadingData.finalDestination;
						param.totalNumber = this.billLadingData.totalNumber;
						param.billGoodsList = this.billLadingData.goodList;
						param.isAddtionalImageDisplay = this.billLadingData.isAddtionalImageDisplay;
						// if (this.addWriteBillForm.signer){
						// 	param.signatureCompanyId = this.addWriteBillForm.signer;
						// }
						if (this.addWriteBillForm.issuingParty_label){
							param.sendCompanyId = this.addWriteBillForm.issuingParty_label;
						}
						if (this.addWriteBillForm.billFormatter){
							param.billFormatter = this.addWriteBillForm.billFormatter;
						}
						if (this.addWriteBillForm.billType){
							param.billType = this.addWriteBillForm.billType;
						}
						if (this.addWriteBillForm.billAdditionalDescription){
							param.billAdditionalDescription = this.addWriteBillForm.billAdditionalDescription;
						}
						if (this.addWriteBillForm.billingFee){
							param.billingFee = this.addWriteBillForm.billingFee;
						}
						if (this.addWriteBillForm.issuingTime){
							param.issuingTime = this.addWriteBillForm.issuingTime;
						}
						if (this.addWriteBillForm.portOfDischarge){
							param.portOfDischarge = this.addWriteBillForm.portOfDischarge;
						}
						if (this.addWriteBillForm.payment){
							param.payment = this.addWriteBillForm.payment;
						}
						if (this.addWriteBillForm.payType){
							param.payType = this.addWriteBillForm.payType;
						}

						// 下拉列表选择后获取图片路径
						param.billLogoName = this.logoPath.substring(this.logoPath.lastIndexOf('/') + 1);
						param.billImageName = this.imagePath.substring(this.imagePath.lastIndexOf('/') + 1);
						// 默认显示TT CLUB 图片

						param.addtionalImageName = this.addtionalImagePath.substring(this.addtionalImagePath.lastIndexOf('/') + 1);

						console.log(param);
						this.$axios({
							method: "post",
							url: "api/receipts/recordInsert", // 接口地址
							data:param
							}).then(res => {
								console.log();
								if(res.data.status==1){
									this.$message({
										// message: this.$t('c_addWriteBill.successMassage'),
										// 2021-01-29 修改消息提示 等待出单方完善
										message: this.$t('c_addWriteBill.operateSuccessMessage'),
										type: 'success',
										center: true
									});
									this.$routerUtil.setParam(this.conditionData.searchForm);
									this.$router.push('WriteBillManage');
								} else {
									this.$message({
										message: this.$t(res.data.message),
										type: 'error',
										center: true
									});
								}
							}).catch(error => {
								console.log(error);
								// this.$message.error('EM-101');
								this.$message({
									message: 'EM-101',
									type: 'error',
									center: true
								});
							});
				} else {
					console.log('error submit!!')
					return false
				}
			});
		},
		doCancel(){
			this.$routerUtil.setParam(this.conditionData.searchForm);
			this.$router.push('WriteBillManage');
		},
		getCompanyName(id){
			let companyName = '';
			this.companyList.forEach(item => {
				if(id === item.id){
					companyName = item.companyName;
				}
			});
			return companyName;
		}
    }
}
